export type NotifyType = 'success' | 'error' | 'info'

export interface NotifyToast {
  id: number
  message: string
  type: NotifyType
}

const MAX_QUEUE = 10
const timers = new Map<number, ReturnType<typeof setTimeout>>()
let seed = 0

export function useNotify() {
  const toasts = useState<NotifyToast[]>('app-notify-toasts', () => [])

  const dismiss = (id: number) => {
    const timer = timers.get(id)
    if (timer) {
      clearTimeout(timer)
      timers.delete(id)
    }
    toasts.value = toasts.value.filter(item => item.id !== id)
  }

  const notify = (
    message: string,
    type: NotifyType = 'success',
    duration = 3000,
  ): number | undefined => {
    if (!import.meta.client) return

    if (toasts.value.length >= MAX_QUEUE) {
      const oldest = toasts.value[0]
      if (oldest) dismiss(oldest.id)
    }

    const id = ++seed
    toasts.value = [...toasts.value, { id, message, type }]
    timers.set(
      id,
      setTimeout(() => dismiss(id), duration),
    )
    return id
  }

  return {
    toasts,
    dismiss,
    notify,
    success: (message: string, duration?: number) => notify(message, 'success', duration ?? 1400),
    error: (message: string, duration?: number) => notify(message, 'error', duration ?? 2600),
    info: (message: string, duration?: number) => notify(message, 'info', duration ?? 2600),
  }
}
